import { render, staticRenderFns } from "./Watcher.vue?vue&type=template&id=6b3f5982&lang=pug"
import script from "./Watcher.vue?vue&type=script&lang=js"
export * from "./Watcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports